import DynamicFormTabs from "@/shared/components/common/customTab";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid, Tab } from "@mui/material";
import ContentFirstTab from "./contentFirstTab";
import ContentSecondTab from "./contentSecondTab";
import { useState } from "react";
import ContentTableAddUser from "./contentTableAddUser";
import CustomMuiTab from "@/shared/components/common/tab/muiTab";
import TabPanel from "@mui/lab/TabPanel";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
/**
 * Content
 *
 * نمایش و مدیریت فرآیند ثبت‌نام مشتریان به صورت انفرادی یا گروهی.
 * این کامپوننت شامل:
 * - بخش توضیحات اولیه برای پذیرنده
 * - تب‌بندی برای انتخاب نوع ثبت‌نام
 * - رندر محتوای فرم‌ها بر اساس تب انتخاب‌شده
 * - نمایش جدول کاربران پس از ثبت نهایی
 *
 * کاملاً سازگار با ریسپانسیو‌سازی برای موبایل، تبلت و دسکتاپ.
 *
 * @returns JSX.Element
 */
const Content = () => {
  const [detailSubmit, setDetailSubmit] = useState(false);
  const handleClickSubmit = () => {
    setDetailSubmit(true);
  };

  const [valueTab, setValueTab] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };

  return (
    <Grid container spacing={3} sx={{display: "flex",flexDirection: "column",}}>
      <StackKit alignItems={"flex-start"} sx={{width: "100%",gap: 1.5,textAlign: { xs: "right", sm: "right" },}}>
        <TypoGraphyKit variant="h6" sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}>
          ثبت نام مشتری
        </TypoGraphyKit>

        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: ".85rem", sm: "1rem" } }}>
          پذیرنده گرامی
        </TypoGraphyKit>

        <TypoGraphyKit variant="body1" sx={{fontSize: { xs: ".85rem", sm: "1rem" },lineHeight: { xs: "1.8", sm: "2" },}}>
          در این بخش شما میتوانید مشتریان خود را به دو صورت انفرادی یا گروهی ثبت نام نمایید.
          چنانچه مشتریانی که قصد ثبت نام آنها را دارید عضو یکی از سازمان‌های تعریف شده در پنل شما هستند،
          سازمان مورد نظر را انتخاب نمایید و در غیر این صورت، سازمان جدید اضافه نمایید.
        </TypoGraphyKit>

        <TypoGraphyKit variant="body1" sx={{ fontSize: { xs: ".85rem", sm: "1rem" } }}>
          پس از ثبت نام از مشتریان خود بخواهید تا با مراجعه به نزدیک ترین گیشه
          {toPersianNumber(20)} کارت فیزیکی خود را دریافت نمایند.
        </TypoGraphyKit>
      </StackKit>

      <StackKit sx={{ width: "100%", mt: 4 }}>
        {!detailSubmit ? (
          <CustomMuiTab
            valueTab={valueTab}
            handleChange={handleChange}
            tabTitle={[
              <Tab sx={{marginRight: "15px",bgcolor: "#2C2C2C",borderTopRightRadius: "10px",borderTopLeftRadius: "10px",minWidth: { xs: "90px", sm: "160px" },fontSize: { xs: ".75rem", sm: ".9rem" },}} label="ثبت نام انفرادی" value="1" key="1"/>,
              <Tab sx={{marginRight: "15px",bgcolor: "#2C2C2C",borderTopRightRadius: "10px",borderTopLeftRadius: "10px",minWidth: { xs: "90px", sm: "160px" },fontSize: { xs: ".75rem", sm: ".9rem" },}} label="ثبت نام گروهی" value="2" key="2"/>,
            ]}
            tabPanel={
              <StackKit sx={{ width: "100%", padding: 0 }}>
                <TabPanel value="1" sx={{ padding: 0 }}>
                  <ContentFirstTab />
                </TabPanel>

                <TabPanel value="2" sx={{ padding: 0, margin: "0 !important" }}>
                  <ContentSecondTab />
                </TabPanel>
              </StackKit>
            }
          />
        ) : (
          <ContentTableAddUser />
        )}
      </StackKit>
    </Grid>
  );
};

export default Content;